import React, {Fragment} from "react";
import {DefaultDataGridState} from "../Types/DefaultDataGridState";
import {GUIProps} from "./Types/GUIProps";
import Row from "./Row";
import {get} from "../../../../../utils/dotutils";

export class Body extends React.Component<GUIProps, DefaultDataGridState> {
    render() {
        const fields = this.props.getFields({onlyVisible: true});
        const items = this.props.data.items;
        let groupField;
        let groupFieldStart = true;
        return (
            <tbody className="p-datatable-tbody">
            {
                items.length ? items.map((item, rowIdx) => {
                    const rowKey = item[this.props.rowKeyField];
                    let head = null;
                    const groupFieldValue = get(item, this.props.groupField);
                    if (this.props.groupField && (groupFieldStart || groupField !== groupFieldValue)) {
                        if (this.props.groupFieldTemplate) {
                            if (this.props.groupFieldTemplate instanceof Function) {
                                head = <this.props.groupFieldTemplate {...this.props} item={item} rowIdx={rowIdx} rowKey={rowKey} items={items} groupFieldValue={groupFieldValue} />;
                            } else {
                                head = <this.props.groupFieldTemplate.type ref={this.props.groupFieldTemplate.ref} {...this.props} groupFieldValue={groupFieldValue} />;
                            }
                        }
                        groupField = groupFieldValue;
                        groupFieldStart = false;
                    }
                    return <Fragment key={rowIdx}>
                        {head}
                        <Row {...this.props} item={item} rowIdx={rowIdx} rowKey={rowKey} items={items} />
                    </Fragment>;
                }) : (!this.props.isLoading && this.props.emptyMessage !== false && <tr>
                    <td className="p-editable-column p-cell-editing" colSpan={fields.length}>
                        <div className="editor-field">
                            <div>
                                {this.props.emptyMessage}
                            </div>
                        </div>
                    </td>
                </tr>)
            }
            </tbody>
        );
    }
}